import { TicketStatusCodes } from "@/data/enums/tickets";
import { FilterOperators, Sorters } from "@/data/table";
import { serialiseConfig } from "@/helpers/table";
import { IMenuRoute } from "@/models/routes";
import i18n from "@/i18n";

export function ticketsTabigation(): (IMenuRoute & { exact?: boolean })[] {
  return [
    {
      label: i18n.t("_.active_tickets"),
      exact: true,
      to: { name: "adminClientSupportTickets" }
    },
    {
      label: i18n.t("_.closed_tickets"),
      exact: true,
      to: {
        name: "adminClientSupportTickets",
        query: {
          TT1: serialiseConfig({
            constFilters: [
              {
                key: "status.code",
                operator: FilterOperators.EQUAL,
                value: TicketStatusCodes.CLOSED
              }
            ],
            sort: {
              field: "updated_at",
              direction: Sorters.DESCENDING
            }
          })
        }
      }
    }
  ];
}
